// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"fa1e28b1","300":"ad17ba9c","304":"ecd1d425","464":"1cdde0ec","880":"f2001eb8","902":"9110b785"}[chunkId] + ".chunk.js";
};